var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"optimize99-ab-test-container",class:{
    'pa-5': _vm.device_type !== 'desktop',
  },style:({
    height: _vm.container_height,
  })},[_c('iframe',{key:_vm.device_type,ref:"iframeRef",staticClass:"optimize99-ab-test-iframe",class:{
      'optimize99-ab-test-iframe-desktop': _vm.device_type === 'desktop',
      'optimize99-ab-test-iframe-tablet': _vm.device_type === 'tablet',
      'optimize99-ab-test-iframe-mobile': _vm.device_type === 'mobile',
    },attrs:{"id":"container_iframe","src":_vm.edit_src},on:{"load":_vm.handleIframeLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }